var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"intro"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.intro.description)}}),_vm._v(" "),_c('nav',[_c('ul',{staticClass:"quick-links"},_vm._l((_vm.sections),function(section,i){return _c('li',{key:i},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
          el: '#' + section.link,
          offset: _vm.elOffset(section.link)
        }),expression:"{\n          el: '#' + section.link,\n          offset: elOffset(section.link)\n        }"}],class:section.link,attrs:{"href":'#' + section.link}},[_vm._v(_vm._s(section.name)+" >")])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-616bb344","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = null
// module chunks = 